import {SIMPLE_VIDEO_MODAL_OPEN} from "../components/VideoModal/VideoModal";

export default {
    methods: {
        getVimeoUrl(id) {
            return `https://player.vimeo.com/video/${id}`;
        },

        getVimeoThumbnailUrl(id) {
            return `https://i.vimeocdn.com/video/${id}.jpg?mw=1920&mh=1080`;
        },

        openVideoModal() {
            this.$bus.$emit(SIMPLE_VIDEO_MODAL_OPEN);
        },
        async getVimeoThumbnailUrlAlt(videoId, size) {
            let src;
            await fetch(`https://vimeo.com/api/v2/video/${videoId}.json`)
                .then(response => {
                    return response.text();
                })
                .then(data => {
                    const { thumbnail_large, thumbnail_medium, thumbnail_small } = JSON.parse(data)[0];
                    switch(size) {
                        case 'large':
                            src = thumbnail_large;
                            break;
                        case 'medium':
                            src = thumbnail_medium;
                            break;
                        case 'small':
                            src = thumbnail_small;
                            break;
                    }
                })
                .catch(error => {
                    console.warn(error);
                });
            return src;
        }
    },
};
